import { Page, Content } from '@backstage/core-components';
import {
  HomePageStarredEntities,
  // HomePageToolkit,
  HomePageTopVisited,
  HomePageRecentlyVisited,
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { Grid, makeStyles } from '@material-ui/core';

import logoServi from '../Root/logo/LogoServi.png';
const LogoHome = () => {
  return <img src={logoServi} height={"80px"} style={{ margin: "20px" }} />;
};

const useStyles = makeStyles(theme => ({
  searchBarInput: {
    maxWidth: '60vw',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '50px',
    boxShadow: theme.shadows[1],
  },
  searchBarOutline: {
    borderStyle: 'none',
  },
}));
33
export const HomePage = () => {
  const classes = useStyles();

  return (
    <SearchContextProvider>
      <Page themeId="home" >
        <Content>
          <Grid container justifyContent="center" spacing={2}  >
            <Grid container item xs={12} justifyContent="center"
            style={{
              backgroundColor: "#333",
              background: "radial-gradient(circle,rgba(51, 51, 51, 1) 0%, rgba(153, 153, 153, 1) 100%)",
              }}>
            <LogoHome />
            </Grid>
            <Grid container item xs={12} justifyContent="center" style={{ marginTop: "10px" }}>
              <HomePageSearchBar
                InputProps={{
                  classes: {
                    root: classes.searchBarInput,
                    notchedOutline: classes.searchBarOutline,
                  },
                }}
                placeholder="Search"
              />
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} md={6}>
                <HomePageTopVisited />
              </Grid>
              <Grid item xs={12} md={6}>
                <HomePageRecentlyVisited />
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={6}>
                <HomePageStarredEntities />
              </Grid>
              {/* <Grid item xs={5}> */}
              {/* <HomePageToolkit tools={tools} /> */}
              {/* </Grid> */}
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
